<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <div class="row align-content-center mb-3">
        <div class="col-md-6">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <div>
              <h1 class="fw-500 typography-headline-lg">Random color</h1>
              <p class="subtitle-1 text-muted mb-3">Get a random and it's complementary color.</p>
            </div>
          </vue-aos>
        </div>
        <div class="col-md-6 text-end d-none d-md-block">
          <button @click="randomGenerator"
                  class="btn btn-primary btn-round btn-xs-full-width btn-micint-rotate ripple p-3">
            <i class="material-icons-outlined me-2">refresh</i>
            New Random Colors
          </button>
        </div>
      </div>

      <!-- COLORS SHOWCASE -->
      <div class="row mb-3 g-2">
        <div class="col-md-8">
          <div class="card card-no-border border-radius-25" :style="{'background-color': randomColor}">
            <div class="card-body text-center my-3 my-lg-5">
              <p class="typography-headline-md mb-2">{{ hexToHtml() }}</p>
              <h2 class="typography-headline-xl fw-500 mb-0">{{ randomColor }}</h2>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-no-border border-radius-25" :style="{'background-color': hexComplementaryColor()}">
            <div class="card-body text-center my-3 my-lg-5">
              <p class="typography-headline-md mb-2">{{ hexToHtml2() }}</p>
              <h2 class="typography-headline-xl fw-500 mb-0">{{ hexComplementaryColor() }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12 d-block d-md-none">
          <!-- REFRESH BUTTON -->
          <button class="btn btn-fab m-0" @click="randomGenerator"><i
              class="material-icons-outlined btn-fab-icon">refresh</i>
          </button>
        </div>
      </div>

      <!-- TABLE COLOR CONVERTER -->
      <div class="row mb-5">
        <div class="col-md-12">
          <div class="card card-outline">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover table-borderless mb-0">
                  <thead>
                  <tr>
                    <th scope="col">Color</th>
                    <th scope="col" class="text-poppins">HEX</th>
                    <th scope="col" class="text-poppins">RGB</th>
                    <th scope="col" class="text-poppins">HSL</th>
                    <th scope="col" class="text-poppins">HSV</th>
                    <th scope="col" class="text-poppins">CMYK</th>
                    <th scope="col" class="text-poppins">Pantone (Or similar)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row"><i class="material-icons" :style="{'color' : randomColor}">circle</i></th>
                    <td v-text="randomColor"></td>
                    <td>{{ hexToRgb() }}</td>
                    <td>{{ hexToHsl() }}</td>
                    <td>{{ hexToHsv() }}</td>
                    <td>{{ hexToCmyk() }}</td>
                    <td>{{ hexToPantone() }}</td>
                  </tr>
                  <tr>
                    <th scope="row"><i class="material-icons" :style="{'color' : hexComplementaryColor()}">circle</i>
                    </th>
                    <td v-text="hexComplementaryColor()"></td>
                    <td>{{ hexToRgb2() }}</td>
                    <td>{{ hexToHsl2() }}</td>
                    <td>{{ hexToHsv2() }}</td>
                    <td>{{ hexToCmyk2() }}</td>
                    <td>{{ hexToPantone2() }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import complementaryColor from 'complementary-color'
import simpleColorConverter from "simple-color-converter";
import VueAos from 'vue-aos'

export default {
  name: 'RandomColor',
  metaInfo: {
    title: 'Random Color Generator',
  },
  components: {Footer, Navbar, VueAos},
  data() {
    return {
      randomColor: '#6b61ff',
    }
  },
  methods: {
    randomGenerator() {
      this.randomColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
    },
    hexComplementaryColor() {
      const hexComplementary = new complementaryColor(this.randomColor)
      return '#' + hexComplementary.hexref;
    },

    hexToHtml(colorHtml) {
      colorHtml = new simpleColorConverter({
        hex: this.randomColor,
        to: 'html',
      })
      return colorHtml.color;
    },
    hexToHtml2(colorHtml) {
      colorHtml = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'html',
      })
      return colorHtml.color;
    },

    hexToRgb(colorRgb) {
      colorRgb = new simpleColorConverter({
        hex: this.randomColor,
        to: 'rgb',
      })
      return 'rgb ' + '(' + colorRgb.color.r + ", " + colorRgb.color.g + ", " + colorRgb.color.b + ')';
    },
    hexToRgb2(colorRgb) {
      colorRgb = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'rgb',
      })
      return 'rgb ' + '(' + colorRgb.color.r + ", " + colorRgb.color.g + ", " + colorRgb.color.b + ')';
    },

    hexToHsl(colorHsl) {
      colorHsl = new simpleColorConverter({
        hex: this.randomColor,
        to: 'hsl',
      })
      return 'hsl ' + colorHsl.color.h.toFixed(0) + '°' + ", " + colorHsl.color.s.toFixed(0) + '%' + ", " + colorHsl.color.l.toFixed(0) + '%';
    },
    hexToHsl2(colorHsl) {
      colorHsl = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'hsl',
      })
      return 'hsl ' + colorHsl.color.h.toFixed(0) + '°' + ", " + colorHsl.color.s.toFixed(0) + '%' + ", " + colorHsl.color.l.toFixed(0) + '%';
    },

    hexToHsv(colorHsv) {
      colorHsv = new simpleColorConverter({
        hex: this.randomColor,
        to: 'hsv',
      })
      return 'hsv ' + colorHsv.color.h.toFixed(0) + '°' + ", " + colorHsv.color.s.toFixed(0) + '%' + ", " + colorHsv.color.v.toFixed(0) + '%';
    },
    hexToHsv2(colorHsv) {
      colorHsv = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'hsv',
      })
      return 'hsv ' + colorHsv.color.h.toFixed(0) + '°' + ", " + colorHsv.color.s.toFixed(0) + '%' + ", " + colorHsv.color.v.toFixed(0) + '%';
    },

    hexToCmyk(colorCmyk) {
      colorCmyk = new simpleColorConverter({
        hex: this.randomColor,
        to: 'cmyk',
      })
      return 'cmyk ' + colorCmyk.color.c + '%' + ", " + colorCmyk.color.m + '%' + ", " + colorCmyk.color.y + '%' + ", " + colorCmyk.color.k + '%';
    },
    hexToCmyk2(colorCmyk) {
      colorCmyk = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'cmyk',
      })
      return 'cmyk ' + colorCmyk.color.c + '%' + ", " + colorCmyk.color.m + '%' + ", " + colorCmyk.color.y + '%' + ", " + colorCmyk.color.k + '%';
    },

    hexToPantone(colorPantone) {
      colorPantone = new simpleColorConverter({
        hex: this.randomColor,
        to: 'pantone',
      })
      return 'Pantone ' + colorPantone.color;
    },
    hexToPantone2(colorPantone) {
      colorPantone = new simpleColorConverter({
        hex: this.hexComplementaryColor(),
        to: 'pantone',
      })
      return 'Pantone ' + colorPantone.color;
    },

  }
}
</script>